<script setup lang="ts">
import type { CommandItem } from '../CommandPalette.vue'

const props = defineProps<{
  item: CommandItem
  active: boolean
}>()
const disabled = computed(() => {
  return (
    props.item.id === 'recent-header' ||
    props.item.id === 'all-header' ||
    props.item.id === 'loading' ||
    props.item.id === 'no-results'
  )
})
const isHeader = computed(() => {
  return props.item.id.endsWith('-header')
})
</script>

<template>
  <li
    class="relative cursor-pointer select-none py-3 px-4"
    :class="{
      'bg-gray-50 cursor-default': disabled,
      'bg-primary-600 text-white': active && !disabled,
      'text-gray-900': !active && !disabled,
    }"
  >
    <div class="flex items-center">
      <div
        v-if="item.icon"
        :class="[item.icon, active ? '!bg-white' : '']"
        class="h-5 w-5 flex-shrink-0"
      ></div>
      <div :class="['ml-3', item.icon ? 'ml-3' : '']">
        <div
          class="font-medium"
          :class="{
            'text-gray-500 text-sm uppercase tracking-wider': isHeader,
          }"
        >
          {{ item.name }}
        </div>
        <div
          v-if="!isHeader"
          class="text-sm"
          :class="{
            'text-primary-100': active,
            'text-gray-500': !active,
          }"
        >
          {{ item.description }}
        </div>
      </div>
    </div>
  </li>
</template>
